export default "__VITE_ASSET__BY5G7hv___"